import React, { useEffect } from 'react';
import { StateModel } from '../../redux/store';
import { connect } from 'react-redux';

interface NavbarProps {
  kunde: string;
}

const Navbar = (props: NavbarProps) => {
  const link =
    props.kunde == 'BEXITY'
      ? 'https://bexity.com/'
      : props.kunde == 'MMT'
      ? '/'
      : props.kunde == 'PHL'
      ? 'https://phl-logistik.de/'
      : 'http://www.weberdata.de';

  const logo =
    props.kunde == 'BEXITY'
      ? '/bexity-logo.png'
      : props.kunde == 'MMT'
      ? '/mmt-logo.png'
      : props.kunde == 'PHL'
      ? '/phl-logo.png'
      : props.kunde == 'GERSTLAUER'
      ? '/gerstlauer-logo.png'
      : '/logo.png';

  useEffect(() => {
    if (props.kunde != 'WDS') {
      const head = document.head;
      const link = document.createElement('link');

      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href =
        props.kunde == 'BEXITY'
          ? 'bexityStyle.css'
          : props.kunde == 'MMT'
          ? 'mmtStyle.css'
          : props.kunde == 'PHL'
          ? 'phlStyle.css'
          : '';

      head.appendChild(link);

      return () => {
        head.removeChild(link);
      };
    }
  }, [props.kunde]);

  return (
    <nav id='navbar'>
      {props.kunde !== 'MMT' && (
        <a href={link} target='_blank' rel='noreferrer'>
          <img className='logo' src={process.env.PUBLIC_URL + logo} />
        </a>
      )}
      {props.kunde == 'MMT' && (
        <img className='logo' src={process.env.PUBLIC_URL + logo} />
      )}
    </nav>
  );
};

const mapStateToProps = (state: StateModel) => ({
  kunde: state.Config.clientKunde?.toUpperCase() ?? 'WDS',
});

export default connect(mapStateToProps, {})(Navbar);
